import React, { useEffect, useState } from "react";
import EventApi from "../../services/event";
import SubscribeToEvent from "../SubscribeToEvent";

// ── Inline styles ─────────────────────────────────────────────────────────────

const S = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0a1628 0%, #0d2b4e 45%, #1a1035 100%)",
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#f0f4ff",
    },
    card: {
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(100,180,255,0.15)",
        borderRadius: "20px",
        padding: "48px 40px",
        textAlign: "center",
        maxWidth: "420px",
        width: "90%",
    },
    icon: {
        fontSize: "64px",
        marginBottom: "16px",
    },
    title: {
        fontSize: "22px",
        fontWeight: "700",
        color: "#e0eaff",
        marginBottom: "8px",
    },
    subtitle: {
        fontSize: "15px",
        color: "#94c8ff",
        margin: 0,
    },
};

// ── Component ─────────────────────────────────────────────────────────────────

const SponsoredRegister = (props) => {
    const sponsorId =
        props?.computedMatch?.params?.sponsor_id ||
        props?.match?.params?.sponsor_id;

    const [sponsor, setSponsor] = useState(null);
    const [status, setStatus] = useState("loading"); // loading | found | not_found | full

    useEffect(() => {
        if (!sponsorId) {
            setStatus("not_found");
            return;
        }

        EventApi.getSponsor(sponsorId)
            .then((resp) => {
                const data = resp?.data?.data || resp?.data;
                if (!data || !data.id) {
                    setStatus("not_found");
                    return;
                }
                setSponsor(data);

                // Verifica se há vagas disponíveis (total_slots = 0 → ilimitado)
                if (data.total_slots > 0 && data.occupied_slots >= data.total_slots) {
                    setStatus("full");
                } else {
                    setStatus("found");
                }
            })
            .catch(() => setStatus("not_found"));
    }, [sponsorId]);

    // ── Loading ────────────────────────────────────────────────────────────

    if (status === "loading") {
        return (
            <div style={S.page}>
                <div style={S.card}>
                    <p style={S.icon}>⏳</p>
                    <p style={S.title}>Carregando...</p>
                </div>
            </div>
        );
    }

    // ── Patrocinador não encontrado ────────────────────────────────────────

    if (status === "not_found") {
        return (
            <div style={S.page}>
                <div style={S.card}>
                    <p style={S.icon}>🔍</p>
                    <p style={S.title}>Patrocinador não encontrado</p>
                    <p style={S.subtitle}>
                        O link que você acessou não corresponde a nenhum patrocinador cadastrado.
                    </p>
                </div>
            </div>
        );
    }

    // ── Vagas esgotadas ────────────────────────────────────────────────────

    if (status === "full") {
        return (
            <div style={S.page}>
                <div style={S.card}>
                    <p style={S.icon}>🚫</p>
                    <p style={S.title}>Vagas esgotadas</p>
                    <p style={S.subtitle}>
                        Todas as vagas disponíveis para <strong>{sponsor.name}</strong> já foram
                        preenchidas. Entre em contato com o patrocinador para mais informações.
                    </p>
                </div>
            </div>
        );
    }

    // ── Renderiza o formulário com o patrocinador travado ──────────────────

    return (
        <SubscribeToEvent
            {...props}
            showSponsorField={false}
            lockedSponsor={sponsor}
        />
    );
};

export default SponsoredRegister;
